var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef, memo } from "react";
var SvgShutdownIcon = function SvgShutdownIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M13.333 0h-2.666v13.333h2.666zm6.438 2.896L17.88 4.788A9.23 9.23 0 0 1 21.335 12 9.33 9.33 0 0 1 12 21.335 9.33 9.33 0 0 1 2.665 12a9.3 9.3 0 0 1 3.439-7.229l-1.88-1.88C1.637 5.093 0 8.347 0 12c0 6.629 5.371 12 12 12s12-5.371 12-12c0-3.652-1.638-6.906-4.229-9.104"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgShutdownIcon);
var Memo = /*#__PURE__*/memo(ForwardRef);
export default Memo;